import Image from 'app/Components/Shared/Image/image';
import React, { useState } from 'react';
import './SelectAccount.scss';
import RadioInput from '../RadioInput/RadioInput';
import Tooltip from 'app/Components/Shared/Tooltip/Tooltip';


/**
 * Generic SelectAccount component.
 * Each account should have: { id, type?, products[], accountInfo: [{ labelText, value }] }
 * @param {Object[]} accounts - List of accounts: { id, type?, products, accountInfo }
 * @param {Function} onSelect - Callback with selected account id
 * @param {string|number} selectedAccountId - Currently selected account id
 * @param {string} [title] - Optional title above the list (e.g. "עם איזה חשבון נתקדם?")
 */
const SelectAccount = ({ accounts, onSelect, selectedAccountId , title}) => {
    const [selectedId, setSelectedId] = useState(selectedAccountId);

    const handleSelect = (account) => {
        if(account.disabled){
            return;
        }
        const id = account.id;
        setSelectedId(id);
        onSelect?.(id);
    };

    const getProductDisplay = (item) => {
        if (item == null) return '';
        if (typeof item === 'string') return item;
        return item.value ?? item.subscriberNo ?? item.label ?? '';
    };

    

    const renderSegment = (segment, i, segments) => {
        const hasEnglish = (str) => /[a-zA-Z]/.test(str);
        const trimmed = segment.trim();
        return (
            <span key={i} dir={hasEnglish(trimmed) ? 'ltr' : 'rtl'} style={{ display: 'inline' }}>
                {hasEnglish(trimmed) && i < segments.length - 1 && <span> , </span>}
                {segment}
                {!hasEnglish(trimmed) && i < segments.length - 1 && <span> , </span>}
            </span>
        );
    };

    const renderType = (typeStr) => {
        if (typeStr == null || typeStr === '') return null;
        const segments = String(typeStr).split(',');
        if (segments.length === 0) return typeStr;
        return segments.map((segment, i) => renderSegment(segment, i, segments));
    };

    if (!accounts?.length) {
        return null;
    }

    return (
        <div className="select-account-container">
            {title && <div className="select-account-title">{title}</div>}
            {accounts.map((account) => (
                <div
                    key={account.id}
                    className={`account-card ${selectedId === account.id ? 'selected' : ''} ${account.disabled ? 'disabled' : ''}`}
                    onClick={() => handleSelect(account)}
                >
                    <div className="account-card-header">
                        {!account.disabled && (
                        <RadioInput
                            id={String(account.id)}
                            name="account-selection"
                            checked={selectedId === account.id}
                            onChange={() => handleSelect(account)}
                        />
                        )}
                        {account.type != null && (
                            <div className="account-type">{renderType(account.type)}</div>
                        )}
                    </div>

                    {Array.isArray(account.products) && account.products.length > 0 && (
                        <div className="subscribers-list-container">
                            {account.products.map((item, index) => (
                                <div key={index} className="subscriber-number">
                                    {getProductDisplay(item)}
                                </div>
                            ))}
                        </div>
                    )}
                    
                    {account.disabled ? ( 
                        <div className="disabled-info">
                            {account.disabledReason}
                            <Image id={`${account.tooltipId}`} src={account.tooltipImage} alt='info' />
                            <Tooltip
                                text={account.tooltipText}
                                placement={'top'}
                                cellcomdefault={true}
                                target={`#${account.tooltipId}`}
                            />                                            
                        </div>
                    ):
                    (Array.isArray(account.accountInfo) && account.accountInfo.length > 0 && (
                        <div className="account-info">
                            {account.accountInfo.map((info, index) => (
                                <div key={index} className="info-row">
                                    {info.labelText && (
                                        <span className="info-label">{info.labelText}</span>
                                    )}
                                    {info.value != null && (
                                        <div className="info-value">{info.value}</div>
                                    )}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default SelectAccount;
